import { combineEpics } from 'redux-observable';
import { _reducer } from './AdvancedSettings.reducers';
import _epics from './AdvancedSettings.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './AdvancedSettings.actions';
